import axios from 'axios';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { AddReVisitRes, AddReVisitPayload } from './Model';
import { setupInterceptorsTo } from '../authenticationInterceptors/Interceptors';

type InitialState = {
  loading: boolean;
  response: AddReVisitRes;
  successMsg: string;
  error: string;
};
const initialState: InitialState = {
  loading: false,
  response: {} as AddReVisitRes,
  successMsg: '',
  error: '',
};

const baseUrl = 'https://erp-ssssh.technicise.eu';
const accessToken = '3703265d357a211:5b86c8948ff269d';

export const addReVisit = createAsyncThunk<AddReVisitRes, AddReVisitPayload>(
  'addReVisit/addReVisit',
  (payload, { rejectWithValue }) => {
    const headers = {
      Accept: 'application/json',
      'Content-type': 'application/json',
      Authorization: `Token ${accessToken}`,
    };
    return setupInterceptorsTo(axios)
      .post(baseUrl + '/api/resource/Token',
        payload.body,
        { headers })
      .then((response) => response.data)
      .catch((error) =>
        rejectWithValue(
          error?.response?.data !== undefined
            ? error?.response?.data[0]?.description !== undefined
              ? error?.response?.data[0]?.description
              : error.response.data.message !== undefined
                ? error.response.data.message
                : 'Something Went Wrong.'
            : 'Something Went Wrong.',
        ),
      )
  }
);

const addReVisitSlice = createSlice({
  name: 'addReVisit',
  initialState,
  reducers: {
    resetReVisitState: (state) => {
      state.response = {} as AddReVisitRes;
      state.error = '';
      state.loading = false;
    },
    updateAddReVisitClearMsg: (state) => {
      state.successMsg = '';
      state.error = '';
    },
    updateAddReVisitClearRes: (state) => {
      state.successMsg = '';
      state.error = '';
      state.response = {} as AddReVisitRes;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addReVisit.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      addReVisit.fulfilled,
      (state, action: PayloadAction<AddReVisitRes>) => {
        state.loading = false;
        state.response = action.payload;
      }
    );
    builder.addCase(addReVisit.rejected, (state, action) => {
      state.loading = false;
      state.response = {} as AddReVisitRes;
      state.successMsg = '';
      state.error = String(action.payload!);
    });
  },
});
export const { updateAddReVisitClearMsg, updateAddReVisitClearRes, resetReVisitState } = addReVisitSlice.actions;
export default addReVisitSlice.reducer;